// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1e67bd3c","186":"a405ac49","272":"f0bed8d1","372":"cab861c9","377":"fcf7a35e","630":"2e193649","738":"96c5335d","841":"0dca4ee1","851":"569d5b38","856":"4fcfcedc"}[chunkId] + ".chunk.js";
};